import { useEffect, useState } from "react";
import GetUserInfoService from "../service/GetUserInfoService";
import useApiStatus from "./useApiStatus";

const useGetUserExtrabonus = ({ onError, typeUser }) => {
  const [userExtrabonus, setUserExtrabonus] = useState();
  const { isLoading, setIsLoading } = useApiStatus({ isLoading: true });

  const productService = new GetUserInfoService();

  const loadUserExtrabonus = async () => {
    if (/promoter/i.test(typeUser) || /customer/i.test(typeUser)) {
      setIsLoading(false);
      return;
    }
    try {
      setIsLoading(true);
      const resBalance = await productService.getWalletExtrabonus(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );
      if (resBalance.messageCode !== 200001) onError(resBalance.messageCode);
      else setUserExtrabonus(resBalance.result);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadUserExtrabonus();
    return () => setUserExtrabonus(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    userExtrabonus,
    isLoading,
  };
};

export default useGetUserExtrabonus;
